var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`minimized-modal`},[_c('button',{class:`${_vm.variant}`,on:{"click":_vm.handleClick}},[_c('dot',{attrs:{"variant":"light","pulse":""}}),_vm._v(" "),(_vm.icon)?_c('icon',{attrs:{"value":_vm.icon}}):_vm._e(),_vm._v("\n\t\t"+_vm._s(_vm.text)+"\n\t")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }